import React, { useState, useEffect } from 'react';
import api from '../services/api';

const UserDataModelsDropdown = ({
  onModelSelect,
  onModelClear,
  selectedModel,
  disabled = false,
  label = "Or Select from Your Data Models:",
  placeholder = "Select a data model...",
  showClearButton = true,
  className = ""
}) => {
  const [userDataModels, setUserDataModels] = useState([]);
  const [isLoadingUserModels, setIsLoadingUserModels] = useState(false);
  const [userModelsError, setUserModelsError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchUserDataModels = async () => {
    setIsLoadingUserModels(true);
    setUserModelsError('');
    try {
      console.log('Fetching user data models...');
      const response = await api.fetchUserDataModels();
      console.log('API Response:', response);
      console.log('Data Models Structure:', response.data?.data_models?.map(model => ({
        id: model.id,
        model_name: model.display_name,
        full_response: model.full_response,
        timestamp: model.timestamp
      })));
      
      if (response && response.data && response.data.data_models) {
        console.log('Data models received:', response.data.data_models);
        setUserDataModels(response.data.data_models);
        
        if (response.data.data_models.length === 0) {
          console.log('No data models found');
          setUserModelsError('No data models found for your account. Create a data model first in the Data Model Generator.');
        } else {
          console.log(`Found ${response.data.data_models.length} data model(s)`);
          setSuccess(`Found ${response.data.data_models.length} data model(s) for your account.`);
        }
      } else {
        console.log('Invalid response format:', response);
        setUserModelsError('No data models found for your account.');
      }
    } catch (error) {
      console.error('Error fetching user data models:', error);
      console.error('Error details:', {
        response: error.response,
        message: error.message,
        stack: error.stack
      });
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to fetch user data models';
      setUserModelsError(errorMessage);
    } finally {
      setIsLoadingUserModels(false);
    }
  };

  const handleModelSelection = (model) => {
    if (onModelSelect) {
      onModelSelect(model);
    }
  };

  const handleClearModel = () => {
    if (onModelClear) {
      onModelClear();
    }
  };

  return (
    <div className={`mb-4 max-w-lg mx-auto ${className}`}>
      <span className="font-semibold text-gray-700 block mb-2">
        {label}
      </span>
      <div className="w-full">
        {/* Dropdown Select for User Data Models */}
        <div className="relative">
          <div className="w-full">
            <div className="relative">
              <select
                className={`w-full px-4 py-2 border rounded-lg shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${disabled ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' : 'bg-white border-gray-300 text-gray-700'}`}
                onChange={(e) => {
                  const selectedModel = userDataModels.find(model => model.id === e.target.value);
                  if (selectedModel) {
                    console.log('Selected model:', selectedModel);
                    handleModelSelection(selectedModel);
                  }
                }}
                onClick={async () => {
                  if (!userDataModels.length) {
                    await fetchUserDataModels();
                  }
                }}
                value={selectedModel?.id || ''}
                disabled={isLoadingUserModels || disabled}
              >
                <option value="">{placeholder}</option>
                {userDataModels.map((model, index) => {
                  const schema = model.etl_schema || {};
                  const tableCount = schema.tables?.length || 0;
                  const modelName = model.display_name;
                  console.log('Model Name:', modelName);
                  return (
                    <option key={model.id || index} value={model.id || index}>
                      {modelName} ({tableCount} tables)
                    </option>
                  );
                })}
              </select>
              {isLoadingUserModels && (
                <div className="absolute right-10 top-1/2 transform -translate-y-1/2">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {userModelsError && (
        <div className="text-red-600 text-xs mt-2">{userModelsError}</div>
      )}
      {selectedModel && showClearButton && (
        <div className="bg-green-50 p-2 rounded border border-green-300 mt-2">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-green-800">
                {selectedModel.display_name || selectedModel.model_name || `Data Model ${selectedModel.id}`}
              </p>
              <p className="text-xs text-green-600">Created: {new Date(selectedModel.timestamp).toLocaleString()}</p>
            </div>
            <button
              onClick={handleClearModel}
              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition text-xs"
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDataModelsDropdown; 